<template>
<v-responsive>
    <v-card class="mt-4 pb-4">
        <v-card-title class="subtitle-1">포트폴리오 카테고리</v-card-title>
        <v-card-text class="pb-0">
            <portfolio-category-select v-model="portfolio.category" :categories="categories" hide-details @input="category => portfolio._category = category._id"></portfolio-category-select>
        </v-card-text>
    </v-card>

    <v-row class="mt-4">
        <v-col cols="7">
            <v-card>
                <v-card-text>
                    <v-text-field v-model="portfolio.subject" label="공사명" placeholder=" " hide-details></v-text-field>
                </v-card-text>
            </v-card>

            <v-card class="mt-2">
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="auto" class="pt-0 pb-0">
                            <v-img v-if="portfolio.thumb" :src="createObjectURL(portfolio.thumb)" width="160" height="120"></v-img>
                            <v-responsive v-else width="160" height="120">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col class="pl-0">
                            <v-file-input v-model="portfolio.thumb" label="썸네일(400*300)"  placeholder=" " show-size accept="image/*"></v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="mt-2">
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="auto" class="pt-0 pb-0">
                            <v-img v-if="portfolio.image" :src="createObjectURL(portfolio.image)" width="160" height="120"></v-img>
                            <v-responsive v-else width="160" height="120">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col class="pl-0">
                            <v-file-input v-model="portfolio.image" label="메인이미지"  placeholder=" " show-size accept="image/*"></v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <portfolio-space v-model="portfolio"></portfolio-space>

        </v-col>
        <v-col cols="5">
             <v-card>
                 <v-card-title class="subtitle-1">
                    견적정보
                 </v-card-title>
                 <v-card-text class="pt-2">
                    <v-date-field v-model="portfolio.construction.estimatedDate" label="견적일자" placeholder=" " dense></v-date-field>
                    <v-text-field v-model="portfolio.construction.address" label="시공지역" placeholder=" " dense class="mt-2" readonly @click="$refs['daum-postcode'].open()"></v-text-field>
                    <v-select v-model="portfolio.construction.scope" label="시공범위" placeholder=" " :items="scopeItems" dense class="mt-4"></v-select>
                    <v-text-field v-model="portfolio.construction.acreage" label="시공면적 (평수)" placeholder=" " type="number" dense @change="value => portfolio.construction.acreage = 200 < value ? 200 : value" class="mt-4"></v-text-field>
                    <v-text-field v-model="portfolio.construction.supplyPrice" label="공급가격 (만원단위)" placeholder=" " type="number" dense @change="value => portfolio.construction.supplyPrice = 200000000 < value ? 200000000 : value" class="mt-4"></v-text-field>
                    <v-text-field v-model="portfolio.construction.discountPrice" label="할인가격 (만원단위)" placeholder=" " type="number" dense @change="value => portfolio.construction.discountPrice = 200000000 < value ? 200000000 : value" class="mt-4"></v-text-field>
                    
                    <div class="subtitle-2">컨셉</div>
                    <v-chip-group v-model="portfolio.construction.concept" label="컨셉" active-class="primary--text" multiple>
                        <v-chip v-for="concept in conceptItems" :value="concept" :key="concept">{{ concept }}</v-chip>
                    </v-chip-group>

                    <v-select v-model="portfolio.construction.color" label="시공 컬러" dense placeholder=" " :items="colorItems" class="mt-8"></v-select>

                    <v-text-field v-model="portfolio.construction.request" label="요구사항" dense placeholder=" " class="mt-4"></v-text-field>
                    <v-text-field v-model="portfolio.construction.details" label="시공설명" dense placeholder=" " class="mt-4"></v-text-field>
                </v-card-text>
            </v-card>
            <v-card class="mt-2">
                <v-card-title class="subtitle-1">
                    <v-row align="center">
                        <v-col cols="auto" class="py-0">견적서</v-col>
                        <v-spacer/>
                        <v-col cols="auto" class="py-0">
                            <v-select v-model="portfolio.estimate.type" dense hide-details :items="estimateTypes" item-text="name" item-value="value"></v-select>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text v-if="portfolio.estimate.type">
                    <v-btn v-if="portfolio.estimate.type == 'data1'" @click="$refs['popup-estimate1'].open()" color="secondary" class="pl-3"><v-icon class="mr-2">{{ mdiFileDocumentEditOutline }}</v-icon>기본 견적서 작성</v-btn>
                    <v-btn v-if="portfolio.estimate.type == 'data2'" @click="$refs['popup-estimate2'].open()" color="secondary" class="pl-3"><v-icon class="mr-2">{{ mdiFileDocumentEditOutline }}</v-icon>상세 견적서 작성</v-btn>
                    <v-file-input v-if="portfolio.estimate.type == 'file'" v-model="portfolio.estimate.file" label="파일첨부" dense hide-details how-size accept="image/*"></v-file-input>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <v-row class="mt-4">
        <v-col cols="12">
            <v-card>
                <v-card-title class="subtitle-1">
                    상세내용
                </v-card-title>
                <v-card-text>
                    <naver-smarteditor v-model="portfolio.content"></naver-smarteditor>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>


    <popup-estimate1 ref="popup-estimate1" v-model="portfolio.estimate"></popup-estimate1>
    <popup-estimate2 ref="popup-estimate2" v-model="portfolio.estimate"></popup-estimate2>
    <daum-postcode ref="daum-postcode" @change="data => portfolio.construction.address = data.address"></daum-postcode>
</v-responsive>
</template>

<script>
import api from "@/api";
import { mdiFileDocumentEditOutline } from '@mdi/js';

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import NaverSmarteditor from '@/components/plugins/naver/naver-smarteditor.vue';

import PortfolioSpace from "@/components/console/portfolio/portfolio-space.vue";
import PortfolioCategorySelect from '@/components/console/portfolio/category/portfolio-category-select.vue';
import PopupEstimate1 from "@/components/console/portfolio/popup-estimate1.vue";
import PopupEstimate2 from "@/components/console/portfolio/popup-estimate2.vue";

export default {
    components: {
        VDateField,

        DaumPostcode,
        NaverSmarteditor,

        PortfolioSpace,
        PortfolioCategorySelect,
        PopupEstimate1,
        PopupEstimate2
    },

    props: {
        value: { type: Object, default: null }
    },

    data(){
        return {
            mdiFileDocumentEditOutline,

            portfolio: this.$props.value,

            categories: [],

            scopeItems: [ "종합인테리어", "부분인테리어", "부분시공" ],
            conceptItems: [ "심플", "모던", "내추럴", "빈티지", "클래식", "럭셔리" ],
            colorItems: [
                "화이트", "아이보리", "옐로",
                "골드", "브라운", "레드",
                "핑크", "퍼플", "블루",
                "그린", "그레이", "블랙"
            ],
            estimateTypes: [
                { name: ":: 견적서 선택 ::", value: "none" },
                { name: "기본견적", value: "data1" },
                { name: "상세견적", value: "data2" },
                { name: "파일첨부", value: "file" }
            ]
        };
    },

    mounted(){
        this.init();
    },
    methods: {
        async init(){
            var { categories } = await api.console.portfolios.categories.getCategories();
            this.categories = categories;

        },
        createObjectURL(file){
            return file ? URL.createObjectURL(file) : null;
        },
    }
}
</script>


